function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.6248 34.2123C13.2163 35.0851 10.6206 35.5992 8.47876 36.9313",
  stroke: "currentColor",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.89191 18.2219C7.69397 17.8551 5.56963 17.6072 3.42163 17.0701",
  stroke: "currentColor",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.366 4.2794C18.47 3.72899 17.345 2.61502 16.3013 2.73543",
  stroke: "currentColor",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgKraftLeft(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-kraft-left",
    width: 22,
    height: 39,
    viewBox: "0 0 22 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKraftLeft);
export default __webpack_public_path__ + "static/media/kraft-left.d2f1d1aa.svg";
export { ForwardRef as ReactComponent };